import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { TOUCH_TARGET_PX } from '../../config/touch-target';
import { useIsMobile } from '../../hooks/use-is-mobile';

interface DeadlineLinksViewAllButtonProps {
  url: string | undefined;
  total: number;
  shownCount: number;
}

/** Opens the full filtered list when the card could not show every match (or none). */
export function shouldShowViewAll({ url, total, shownCount }: DeadlineLinksViewAllButtonProps) {
  return Boolean(url) && total > 0 && (shownCount === 0 || total > shownCount);
}

export function DeadlineLinksViewAllButton({
  url,
  total,
  shownCount,
}: DeadlineLinksViewAllButtonProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  if (!url || !shouldShowViewAll({ url, total, shownCount })) {
    return null;
  }
  return (
    <Button
      data-testid="deadline-links-view-all"
      fullWidth={isMobile}
      onClick={() => navigate(url)}
      startIcon={<OpenInNewOutlinedIcon />}
      sx={{ alignSelf: 'flex-start', minHeight: TOUCH_TARGET_PX, textTransform: 'none' }}
      variant="contained"
    >
      {t('guida.assistant.deadlineLinks.viewAll', {
        count: total,
        defaultValue: 'Vedi tutte ({{count}})',
      })}
    </Button>
  );
}
